import React from 'react';
import { Route, Routes } from "react-router-dom";

import Home from "../page/home";
import Product from "../page/product";
import Login from "../page/login";
import Cart from "../page/cart";
import Register from '../page/register';
import LoginAdmin from '../page/admin/login';
import Checkout from '../page/checkout';
import Profile from '../page/profile';
import PersonalInfo from '../page/profile/personalInfo';
import AccountOrders from '../page/profile/accountOrders';
import Addresses from '../page/profile/addresses';
import Vouchers from '../page/profile/vouchers';
import AccountNotifications from '../page/profile/accountNotifications';
import Devices from '../page/profile/devices';
import Privacy from '../page/profile/privacy';
import CopyrightNotice from '../page/profile/copyright';
import AccountPassword from '../page/profile/accountPassword';
import CategoryChild from '../page/category/detail';
import BookDetail from '../page/book/detail';
import CategoryIndex from '../page/categoryIndex';
import Book from '../page/book';
import WindowsBooksGuide from '../page/book/windows';
import SearchPage from '../page/searchPage';
import LatestProducts from "../page/latestProducts";
import ToolPage from '../page/toolPage';
import MoneyPage from '../page/moneyPage';
import ToolDetail from '../page/toolPage/detail';
import Affiliate from '../page/moneyPage/detail';
import Blog from '../page/blog';
import BlogDetail from '../page/blog/detail';
import InstructionMoney from '../page/moneyPage/instruction';
import CategoryBlogDetail from '../page/blog/categoryDetail';
import ForgotPass from '../page/forgotPass';
import ChangePass from '../page/profile/changePass';
import MoneyDetail from '../page/moneyPage/detailMakeMoney';
import SendTaskMoney from '../page/profile/sendTaskMoney';
import ViewDetailTask from '../page/moneyPage/viewDetailTask';
import HistoryRqMoney from '../page/profile/historyRqMoney';
import RefundMoneyDetail from '../page/moneyPage/detailRefundMoney';
import SendTaskRefundMoney from '../page/profile/sendTaskRefundMoney';
import ViewDetailRefundTask from '../page/moneyPage/viewDetailRefundTask';

import NewCategory from '../page/newCategory';

import TienIch from '../page/tienIch';
import TienIchSucKhoe from '../page/tienIchSucKhoe';
import ExtraHealthTracker from '../page/tienIchSucKhoe/extraTracker';
import TienIchPhucHoiChucNang from '../page/tienIchPhucHoiChucNang';
import TienIchDinhDuong from '../page/tienIchDinhDuong';
import NutritionToolDetail from '../page/tienIchDinhDuong/detail';
import TienIchCongCuYKhoa from '../page/tienIchCongCuYKhoa';
import MedicalToolDetail from '../page/tienIchCongCuYKhoa/detail';


import HuyetAp from '../page/tienIchSucKhoe/huyetAp';
import DuongHuyet from '../page/tienIchSucKhoe/duongHuyet';
import Spo2 from '../page/tienIchSucKhoe/spo2';
import NhipTim from '../page/tienIchSucKhoe/nhipTim';
import LichThuoc from '../page/tienIchSucKhoe/lichThuoc';
import LichTaiKham from '../page/tienIchSucKhoe/lichTaiKham';


/*
 * PHỤC HỒI CHỨC NĂNG
 */
import NhatKyDau from '../page/tienIchPhucHoiChucNang/nhatKyDau';
import Rom from '../page/tienIchPhucHoiChucNang/rom';
import Barthel from '../page/tienIchPhucHoiChucNang/barthel';
import Berg from '../page/tienIchPhucHoiChucNang/berg';
import Tug from '../page/tienIchPhucHoiChucNang/tug';
import Mrc from '../page/tienIchPhucHoiChucNang/mrc';


export default function User() {

    return (

        <Routes>


            {/* TRANG CHỦ */}

            <Route
                path="/"
                element={<Home />}
            />


            {/* TÀI KHOẢN */}

            <Route
                path="/dang-nhap"
                element={<Login />}
            />

            <Route
                path="/dang-nhap-admin"
                element={<LoginAdmin />}
            />

            <Route
                path="/dang-ky"
                element={<Register />}
            />

            <Route
                path="/quen-mat-khau"
                element={<ForgotPass />}
            />

            <Route
                path="/doi-mat-khau"
                element={<ChangePass />}
            />


            {/* =========================
                DANH MỤC
            ========================== */}

            <Route
                path="/danh-muc-trang-chu/:id"
                element={<CategoryIndex />}
            />

            <Route
                path="/danh-muc-san-pham/:slug"
                element={<NewCategory />}
            />

            <Route
                path="/danh-muc-moi"
                element={<NewCategory />}
            />

            <Route
                path="/danh-muc-con/:slug"
                element={<CategoryChild />}
            />


            {/* SẢN PHẨM */}

            <Route
                path="/san-pham/:slug"
                element={<Product />}
            />


            {/* GIỎ HÀNG */}

            <Route
                path="/gio-hang"
                element={<Cart />}
            />

            <Route
                path="/thanh-toan"
                element={<Checkout />}
            />


            {/* THÔNG TIN CÁ NHÂN */}

            <Route
                path="/thong-tin-ca-nhan"
                element={<Profile />}
            />


            <Route
                path="/tai-khoan/thong-tin-ca-nhan"
                element={<PersonalInfo />}
            />

            <Route
                path="/tai-khoan/don-hang"
                element={<AccountOrders />}
            />

            <Route
                path="/tai-khoan/dia-chi"
                element={<Addresses />}
            />

            <Route
                path="/tai-khoan/voucher"
                element={<Vouchers />}
            />

            <Route
                path="/tai-khoan/thong-bao"
                element={<AccountNotifications />}
            />

            <Route
                path="/tai-khoan/doi-mat-khau"
                element={<AccountPassword />}
            />

            <Route
                path="/tai-khoan/thiet-bi"
                element={<Devices />}
            />

            <Route
                path="/tai-khoan/chinh-sach-bao-mat"
                element={<Privacy />}
            />

            <Route
                path="/tai-khoan/ban-quyen"
                element={<CopyrightNotice />}
            />


            {/* SÁCH */}

            <Route
                path="/sach-cua-toi"
                element={<Book />}
            />


            <Route
                path="/sach-cua-toi/windows"
                element={<WindowsBooksGuide />}
            />

            <Route
                path="/sach-cua-toi/:slug"
                element={<BookDetail />}
            />


            {/* TÌM KIẾM */}

            <Route
                path="/san-pham-moi"
                element={<LatestProducts />}
              />
              <Route
                path="/tim-kiem/:keyword"
                element={<SearchPage />}
            />


            {/* CÔNG CỤ */}

            <Route
                path="/cong-cu"
                element={<ToolPage />}
            />

            <Route
                path="/cong-cu/:id"
                element={<ToolDetail />}
            />


            {/* =========================
                TIỆN ÍCH
            ========================== */}

            <Route
                path="/tienich"
                element={<TienIch />}
            />


            {/* THEO DÕI SỨC KHỎE */}

            <Route
                path="/tienich/suc-khoe"
                element={<TienIchSucKhoe />}
            />

            <Route
                path="/tienich/suc-khoe/theo-doi/:slug"
                element={<ExtraHealthTracker />}
            />

            <Route
                path="/tienich/suc-khoe/huyet-ap"
                element={<HuyetAp />}
            />

            <Route
                path="/tienich/suc-khoe/duong-huyet"
                element={<DuongHuyet />}
            />

            <Route
                path="/tienich/suc-khoe/spo2"
                element={<Spo2 />}
            />

            <Route
                path="/tienich/suc-khoe/nhip-tim"
                element={<NhipTim />}
            />

            <Route
                path="/tienich/suc-khoe/lich-thuoc"
                element={<LichThuoc />}
            />

            <Route
                path="/tienich/suc-khoe/lich-tai-kham"
                element={<LichTaiKham />}
            />


            {/* =========================
                PHỤC HỒI CHỨC NĂNG
            ========================== */}

            <Route
                path="/tienich/dinh-duong"
                element={<TienIchDinhDuong />}
            />

            <Route
                path="/tienich/dinh-duong/:slug"
                element={<NutritionToolDetail />}
            />

            <Route
                path="/tienich/cong-cu-y-khoa"
                element={<TienIchCongCuYKhoa />}
            />

            <Route
                path="/tienich/cong-cu-y-khoa/:slug"
                element={<MedicalToolDetail />}
            />

            <Route
                path="/tienich/phuc-hoi-chuc-nang"
                element={<TienIchPhucHoiChucNang />}
            />

            <Route
                path="/tienich/phuc-hoi-chuc-nang/nhat-ky-dau"
                element={<NhatKyDau />}
            />

            <Route
                path="/tienich/phuc-hoi-chuc-nang/rom"
                element={<Rom />}
            />

            <Route
                path="/tienich/phuc-hoi-chuc-nang/barthel"
                element={<Barthel />}
            />

            <Route
                path="/tienich/phuc-hoi-chuc-nang/berg"
                element={<Berg />}
            />

            <Route
                path="/tienich/phuc-hoi-chuc-nang/tug"
                element={<Tug />}
            />

            <Route
                path="/tienich/phuc-hoi-chuc-nang/mrc"
                element={<Mrc />}
            />


            {/* =========================
                KIẾM TIỀN - GIỮ NGUYÊN
            ========================== */}

            <Route
                path="/kiem-tien"
                element={<MoneyPage />}
            />

            <Route
                path="/kiem-tien/:slug"
                element={<InstructionMoney />}
            />

            <Route
                path="/nhiem-vu-kiem-tien/:slug"
                element={<MoneyDetail />}
            />

            <Route
                path="/nhiem-vu-hoan-tien/:slug"
                element={<RefundMoneyDetail />}
            />

            <Route
                path="/tiep-thi-lien-ket"
                element={<Affiliate />}
            />


            {/* BLOG */}

            <Route
                path="/blog"
                element={<Blog />}
            />

            <Route
                path="/blog/:slug"
                element={<BlogDetail />}
            />

            <Route
                path="/danh-muc-blog/:slug"
                element={<CategoryBlogDetail />}
            />


            {/* NHIỆM VỤ */}

            <Route
                path="/nhiem-vu-da-nop"
                element={<SendTaskMoney />}
            />

            <Route
                path="/nhiem-vu-kiem-tien"
                element={<ViewDetailTask />}
            />

            <Route
                path="/hoan-tien-mua-sam"
                element={<ViewDetailRefundTask />}
            />

            <Route
                path="/lich-su-rut-tien"
                element={<HistoryRqMoney />}
            />

            <Route
                path="/nhiem-vu-hoan-tien-da-nop"
                element={<SendTaskRefundMoney />}
            />


        </Routes>
    );
}